/**
 * 游戏侧语言KEY枚举
 */
export enum LANG {
  CHS = 'CHS', // 简体中文
  EN = 'EN', // 英语
  TR = 'TR', // 土耳其
  PTBR = 'PTBR', // 巴西葡萄牙
  ESLA = 'ESLA', // 拉美西班牙
}

/**
 * 游戏侧语言数值（后台需要）
 */
export const LangCodeMap = {
  [LANG.CHS]: 1,
  [LANG.EN]: 2,
  [LANG.TR]: 13,
  [LANG.PTBR]: 15,
  [LANG.ESLA]: 16,
};

/**
 * momentjs 本地化配置（https://momentjs.com/）
 */
export const MomentLocaleMap = {
  [LANG.CHS]: 'zh-cn',
  [LANG.EN]: 'en',
  [LANG.TR]: 'tr',
  [LANG.PTBR]: 'pt-br',
  [LANG.ESLA]: 'es',
};

/**
 * 项目常量
 */
export const HOK_SCHEMA = 'pbpsdkhok://';
export const HOK_OFFCIAL_WEBSITE = 'https://www.honorofkings.com/';
export const HOK_GAME_ID = '29134';
